// extracted by mini-css-extract-plugin
export default {"Products":"Products_Products__YOhXI","product":"Products_product__npZOX","image":"Products_image__rtxgf","shine":"Products_shine__4ale-","prices":"Products_prices__5mCQ6"};